import { Subject } from 'rxjs/Subject';
import { AxiosInstance, AxiosPromise, CancelTokenSource } from 'axios';
import { IEventBusService } from '@/app-modules/event-bus/event-bus-service';


export type ServerMessageType = 'xml' | 'json';

export interface IWebsocketConnectionOptions {
    serverUrl: string;
    format: ServerMessageType;
    partialMessages?: boolean;
    connectionTimeout?: IConnectionTimeout;
    connectionLogger: IServerConnectionLogger;
    eventBusService: IEventBusService;
    keepAliveConfigCallback?: TimeoutConfigCallback;
    connectionLostConfigCallback?: TimeoutConfigCallback;
    enableKeepAlive?: boolean;
}

export interface IConnectionTimeout {
    timeout: number;
    maxConnectionAttempts: number;
}

export interface IServer {
    url(): string;
    logger(): IServerConnectionLogger;
    connect(retryInfo?: IRetryInfo): Promise<void>;
    disconnect(force: boolean): Promise<void>;
    send(): void;
}

export interface ILongPollerConnection extends IServerConnection {
    proxyUrl: string;
    messageNo: number;
    requestNo: number;
    sessionGuid?: string;
    isDisconnecting: boolean;
    isPolling: boolean;
    commandQueue: IServerCommand[];
    activeRequest?: Promise<void>;
    http: AxiosInstance;
    source: CancelTokenSource;
}

export interface IServerConnection {
    serverUrl: string;
    stream$: Subject<IServerResponse>;
    error$: Subject<Error>;
    errorStatus$: Subject<any>;
    connectionStatus$: Subject<IConnectionStatus>;

    logger(): IServerConnectionLogger;
    connect(retryInfo?: IRetryInfo): Promise<any>;
    disconnect(force: boolean): Promise<any>;
    send(command?: IServerCommand): any;
    sendOfflineMessageBuffer(): void;
}

export interface IServerCommand {
    toPayload(): string;
}

export interface IServerResponse {
    Contents: string;
    Number?: number;
}

export interface IGenericGameServerOptions {
    CONFIG: any;
    CONNECTION_ATTEMPTS: number;
    TIME_UNTIL_RETRY_IN_MILLISECONDS: number;
    SILENCE_DURATION_IN_MILLISECONDS: number;
    FORCE_LONG_POLLING: boolean;
    AuthenticationCommand: any;
    streamCreator(): IGenericGameServerResponseStreams;
}

export interface IGenericGameServerResponseStreams {
    catchup$: Subject<any>;
    authentication$: Subject<any>;
}

export enum ConnectionState {
    CONNECTING = 'CONNECTING',
    CONNECTED = 'CONNECTED',
    CONNECTION_LOST = 'CONNECTION_LOST',
    DISCONNECTING = 'DISCONNECTING',
    DISCONNECTED = 'DISCONNECTED',
    RETRY_CIRCUIT_BROKEN = 'RETRY_CIRCUIT_BROKEN'
}

export interface IConnectionStatus {
    STATE: ConnectionState;
}

export interface IRetryPolicySettings {
    enabled: boolean;
    maxRetries?: number;
    stepPattern?: (currentRetryAttempt: number) => number;
}

export interface IServerConnectionLogger {
    log(message: any, data?: any): void;
    debug(message: any, data?: any): void;
    error(message: any, data?: any): void;
}

export interface IRetryInfo {
  retryAttempt: number;
  maxRetries: number;
}

export type TimeoutConfigCallback = (connection: IServerConnection, retryInfo?: IRetryInfo) => number;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/server-communications/types/index.ts